import { client } from './index';

export type TemporalRuntimeConfig = {
  namespace: string;
  webUiUrl: string;
};

let cached: Promise<TemporalRuntimeConfig> | null = null;

export const getTemporalConfig = (): Promise<TemporalRuntimeConfig> => {
  if (!cached) {
    cached = client
      .get<TemporalRuntimeConfig>('/temporal-config')
      .then((res) => ({
        namespace: res.data.namespace,
        webUiUrl: res.data.webUiUrl,
      }))
      .catch((err) => {
        cached = null;
        throw err;
      });
  }
  return cached;
};
